import React, { useEffect, useRef } from 'react';
import cn from 'clsx';
import styles from './styles.module.scss';
import { DropDownList } from '@components-clean/core/drop-down-list';
import { TextBox } from '@components-clean/core/text-box';

const FontsPage = () => {
    interface DropDownListOption {
        id: number;
        value: string;
        groupedBy?: string;
        disabled?: boolean;
    }
    const data: DropDownListOption[] = ['8px', '12px', '16px', '18px', '20px', '24px', '30px'].map((size, index) => ({
        id: index + 1,
        value: size,
        active: index !== 0,
    }));

    const [sampleText, setSampleText] = React.useState('Lorem ipsum dolor sit amet, consectetur adipiscing elit.');
    const [fontSize, setFontSize] = React.useState(data[3]);
    const elementRef = useRef<HTMLSpanElement>(null);
    const monoElementRef = useRef<HTMLSpanElement>(null);
    const [primaryFontFamily, setPrimaryFontFamily] = React.useState('');
    const [monoFontFamily, setMonoFontFamily] = React.useState('');

    useEffect(() => {
        if (elementRef.current) {
            const computedStyles = getComputedStyle(elementRef?.current);
            setPrimaryFontFamily(computedStyles.fontFamily.split(',')[0]);
        }
    }, [elementRef]);

    useEffect(() => {
        if (monoElementRef.current) {
            const computedStyles = getComputedStyle(monoElementRef.current);
            setMonoFontFamily(computedStyles.fontFamily.split(',')[0]);
        }
    }, [monoElementRef]);

    return (
        <div>
            <div style={{ minWidth: 150, maxWidth: 450 }}>
                <TextBox
                    name="textSampleTextInputDisabled"
                    data-testid="text-input-sample-text"
                    label="Sample Text"
                    maxLength={70}
                    value={sampleText}
                    onChange={(event) => {
                        setSampleText(event.target.value as string);
                    }}
                />
            </div>
            <div style={{ minWidth: 150, maxWidth: 450 }}>
                <DropDownList
                    data={data}
                    textField="value"
                    data-testid="dropdownFontSize"
                    label="Font Size"
                    value={fontSize}
                    onChange={(e) => {
                        if (e.value) setFontSize(e.value as DropDownListOption);
                    }}
                />
            </div>
            <div>
                <h3>{primaryFontFamily} Light (100)</h3>
                <div>
                    <span ref={elementRef} style={{ fontSize: fontSize.value, fontWeight: 100 }}>
                        {sampleText}
                    </span>
                </div>
                <div>
                    <span style={{ fontSize: fontSize.value, fontWeight: 100, fontStyle: 'italic' }}>{sampleText}</span>
                </div>
            </div>
            <div>
                <h3>{primaryFontFamily} Thin (300)</h3>
                <div>
                    <span style={{ fontSize: fontSize.value, fontWeight: 300 }}>{sampleText}</span>
                </div>
                <div>
                    <span style={{ fontSize: fontSize.value, fontWeight: 300, fontStyle: 'italic' }}>{sampleText}</span>
                </div>
            </div>
            <div>
                <h3>{primaryFontFamily} Regular (400)</h3>
                <div>
                    <span style={{ fontSize: fontSize.value, fontWeight: 400 }}>{sampleText}</span>
                </div>
                <div>
                    <span style={{ fontSize: fontSize.value, fontWeight: 400, fontStyle: 'italic' }}>{sampleText}</span>
                </div>
            </div>
            <div>
                <h3>{primaryFontFamily} Medium (500)</h3>
                <div>
                    <span style={{ fontSize: fontSize.value, fontWeight: 500 }}>{sampleText}</span>
                </div>
                <div>
                    <span style={{ fontSize: fontSize.value, fontWeight: 500, fontStyle: 'italic' }}>{sampleText}</span>
                </div>
            </div>
            <div>
                <h3>{primaryFontFamily} Bold (600)</h3>
                <div>
                    <span style={{ fontSize: fontSize.value, fontWeight: 600 }}>{sampleText}</span>
                </div>
                <div>
                    <span style={{ fontSize: fontSize.value, fontWeight: 600, fontStyle: 'italic' }}>{sampleText}</span>
                </div>
            </div>
            <div>
                <h3>{primaryFontFamily} Black (900)</h3>
                <div>
                    <span style={{ fontSize: fontSize.value, fontWeight: 900 }}>{sampleText}</span>
                </div>
                <div>
                    <span style={{ fontSize: fontSize.value, fontWeight: 900, fontStyle: 'italic' }}>{sampleText}</span>
                </div>
            </div>
            <div>
                <h3>{monoFontFamily} (400)</h3>
                <div>
                    <span ref={monoElementRef} className={cn(styles.triMonoFont)} style={{ fontSize: fontSize.value }}>
                        {sampleText}
                    </span>
                </div>
                <div>
                    <span className={cn(styles.triMonoFont)} style={{ fontSize: fontSize.value, fontStyle: 'italic' }}>
                        {sampleText}
                    </span>
                </div>
            </div>
        </div>
    );
};

export default FontsPage;
